import styled from 'styled-components';
import { flexBoxCenter, layerA } from 'shared/styles/commonStyles';
import System from './system/System';
import { useEffect, useState } from 'react';
import WeatherBox from 'shared/components/commonComponentsMC/WeatherBox';
import TitleBar from './TitleBar';
import SpecificLocationReportStatus from './SpecificLocationReportStatus';
import {
  getFaultsAlertsHandler,
  getWifiAlertStatusHandler,
} from 'shared/helpers/helpers';

const EachLocationReportStatus = ({
  location,
  mainIndex,



}) => {
  const [locationId] = Object.keys(location);
  const [faults, setFaults] = useState([]);
  const [systemEbp, setSystemEbp] = useState([]);
  const [systemGp, setSystemGp] = useState([]);
  const [isWeatherForecast, setIsWeatherForecast] = useState(false);
  const [, setParentLocationId] = useState(null);
  const [displaySpecificLocations, setDisplaySpecificLocations] =
    useState(false);
  const [filteredSwitches, setFilteredSwitches] = useState([]);

  let isSpecificLocation;
  Object.values(location).forEach((el) => {
    Object.keys(el).forEach((key) => {
      el[key].forEach((item) => {
        isSpecificLocation = Object.keys(item).includes('subLocationName');
      });
    });

  });

  let switches = [];
  let specificLocations = [];
  let filteredSystems = [];
  if (!isSpecificLocation) {
    switches = Object.entries(Object.values(location)[0]);
  } else {

    specificLocations = Object.values(location).map((locationData) => {
      const subLocations = {};
      Object.keys(locationData).forEach((key) => {
        locationData[key].map((sub) => {
          if (!subLocations[sub.subLocationName]) {
            subLocations[sub.subLocationName] = [];
          }
          subLocations[sub.subLocationName].push([
            key,
            sub.machines.map((el) => ({ [el.machineName]: el.machineDetails })),
          ]);
        });
      });
      return subLocations;
    });
    Object.values(location).forEach((locationData) => {
      const result = Object.entries(locationData);
      filteredSystems = result.reduce((acc, system) => {
        const machines = system[1]
          .filter((subLocation) => subLocation.machines.length)
          .flatMap((subLocation) => subLocation.machines);
        return machines.length
          ? [
              ...acc,
              [
                system[0],
                machines.map((el) => ({ [el.machineName]: el.machineDetails })),
              ],
            ]
          : acc;
      }, []);
    });



















  }






































































  useEffect(() => {

    if (!isSpecificLocation) {
      const { faultsState, filteredData } = getFaultsAlertsHandler(switches);
      setFaults(faultsState);
      setFilteredSwitches(filteredData);
    }












    const essEbp = getWifiAlertStatusHandler(
      'essSwitches',
      'isEbp',
      location,
      !isSpecificLocation
    );

    const tgsEbp = getWifiAlertStatusHandler(
      'tgsSwitches',
      'isEbp',
      location,
      !isSpecificLocation
    );

    const tesEbp = getWifiAlertStatusHandler(
      'tesSwitches',
      'isEbp',
      location,
      !isSpecificLocation
    );

    const combinedEbp = [...essEbp, ...tgsEbp, ...tesEbp];

    setSystemEbp(combinedEbp);



    const essGp = getWifiAlertStatusHandler(
      'essSwitches',
      'isGp',
      location,
      !isSpecificLocation
    );

    const tgsGp = getWifiAlertStatusHandler(
      'tgsSwitches',
      'isGp',
      location,
      !isSpecificLocation
    );

    const tesGp = getWifiAlertStatusHandler(
      'tesSwitches',
      'isGp',
      location,
      !isSpecificLocation
    );

    const combinedGp = [...essGp, ...tgsGp, ...tesGp];

    setSystemGp(combinedGp);
  }, [location]);










































  const displaySpecificLocationsHandler = (locationId) => {
    setDisplaySpecificLocations((prev) => !prev);
    setParentLocationId(locationId);
  };

  const displayWithSpecificLocationSystems = (
    <SystemBaseLayer1>
      <SystemBaseLayer2>
        <SystemWrapper>
          {filteredSystems.map((system, systemIdx) => {
            return (
              <System
                key={system}
                systemIndex={systemIdx}
                switchMachines={system}
                isFault={faults.length > 0 && faults}
                systemEbp={systemEbp}
                systemGp={systemGp}
                locationId={locationId}
                withSpecificLocations={true}


              />
            );
          })}
        </SystemWrapper>
        {displaySpecificLocations &&
          specificLocations.map((specificLocation, specificLocationIdx) => {
            return Object.keys(specificLocation).map(
              (specificLocationKey, specificLocationId) => {
                const specLocationValue = specificLocation[specificLocationKey];
                return (
                  <SpecificLocationReportStatus
                    key={specificLocationKey}

                    specLocationKey={specificLocationKey}
                    specLocationValue={specLocationValue}
                    specificLocationIdx={specificLocationId}
                    location={location}
                    locationKey={locationId}

                  />
                );
              }
            );
          })}
      </SystemBaseLayer2>
    </SystemBaseLayer1>
  );

  const displayOnlyLocationSystems = (
    <SystemBaseLayer1>
      <SystemBaseLayer2>
        <SystemWrapper>
          {filteredSwitches?.map((el, idx) => {
            return (
              <System
                key={el}
                mainIndex={mainIndex}
                systemIndex={idx}
                switchMachines={el}
                isFault={faults.length > 0 && faults}

                systemEbp={systemEbp}
                systemGp={systemGp}
                locationId={locationId}
              />
            );
          })}
        </SystemWrapper>
      </SystemBaseLayer2>
    </SystemBaseLayer1>
  );











  return (
    <Wrapper>
      {isWeatherForecast && (
        <WeatherBoxWrapper>
          <WeatherBox
            handleCloseWeatherBox={setIsWeatherForecast}
            locationId={locationId}

          />
        </WeatherBoxWrapper>
      )}
      <LocationBaseLayer>
        <LocationWrapper>
          <TitleBarWrapper>
            <TitleBar
              expandSpecificLocations={displaySpecificLocations}
              expandButtonHandler={displaySpecificLocationsHandler}
              location={location}
              handleCloseWeatherBox={setIsWeatherForecast}
              noSpecificLocation={!isSpecificLocation}
            />
          </TitleBarWrapper>

          {!isSpecificLocation
            ? displayOnlyLocationSystems
            : displayWithSpecificLocationSystems}
        </LocationWrapper>
      </LocationBaseLayer>
    </Wrapper>
  );
};

export default EachLocationReportStatus;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;

  position: relative;
`;

const WeatherBoxWrapper = styled.div`
  position: absolute;
  z-index: 10;
`;

const LocationBaseLayer = styled.div`
  width: 1220px;
  height: auto;
  margin-bottom: 10px;
  padding: 2px;

  background: #233a54 0% 0%;
  box-shadow: inset 0px 0px 2px #000000;
  border-radius: 19px 19px 40px 40px;

  ${flexBoxCenter}
`;

const LocationWrapper = styled.div`
  width: 1216px;
  height: auto;
  padding-top: 3px;
  padding-bottom: 3px;
  border-radius: 18px 18px 39px 39px;
  border: 0.5px solid #000000;

  ${layerA};
  ${flexBoxCenter};


  flex-direction: column;
  gap: 2px;
`;

const TitleBarWrapper = styled.div`
  width: 1209px;
  height: 32px;
`;

const SystemBaseLayer1 = styled.div`
  width: 1210px;
  height: auto;
  min-height: 90px;
  padding: 2px;

  background: #233a54 0% 0%;
  box-shadow: inset 0px 0px 2px #000000;
  border-radius: 13px 13px 37px 37px;

  ${flexBoxCenter}
`;

const SystemBaseLayer2 = styled.div`
  width: 100%;
  height: auto;
  min-height: 88px;
  padding: 5px;

  background: transparent linear-gradient(180deg, #233a54 0%, #060d19 100%) 0%
    0%;
  box-shadow: inset 0px 0.5px 1px #ffffff29, 0px 0px 1px #000000;
  border: 0.5px solid #000000;
  border-radius: 11px 11px 35px 35px;

  ${flexBoxCenter}
  flex-direction: column;
`;

const SystemWrapper = styled.div`
  width: 1192px;
  height: auto;
  padding: 2px;


  background: #233a54 0% 0% no-repeat padding-box;
  box-shadow: inset 0px 0px 2px #000000;
  border-radius: 37px;

  ${flexBoxCenter}
  flex-direction: column;
  gap: 6px;
`;
